/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectStagesQueryResult } from '../../models/get-project-stages-query-result';

export interface ApiProjectStagesGetProjectStagesGet$Plain$Params {
  ProjectId?: string;
}

export function apiProjectStagesGetProjectStagesGet$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectStagesGetProjectStagesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectStagesQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectStagesGetProjectStagesGet$Plain.PATH, 'get');
  if (params) {
    rb.query('ProjectId', params.ProjectId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectStagesQueryResult>;
    })
  );
}

apiProjectStagesGetProjectStagesGet$Plain.PATH = '/api/ProjectStages/GetProjectStages';
